<template>
    <div class="page-container">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body">

            <div class="container-fluid">
                <h1 class="mb-6">{{ pageTitle }}</h1>

                <div class="list mb-12">

                    <router-link tag="div" class="list-item" to="/booking/workplace">
                        <h3 class="mb-0">Boka tid på din arbetsplats <img
                            src="/images/card/list-headline-arrow-primary.svg" class="headline-arrow"></h3>
                    </router-link>

                    <router-link tag="div" class="list-item" to="/booking/clinic">
                        <h3 class="mb-0">Boka tid på en mottagning <img
                            src="/images/card/list-headline-arrow-primary.svg" class="headline-arrow"></h3>
                    </router-link>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

import scrollMixin from '../../../shared/mixins/scrollMixin'

export default {

    mixins: [
        scrollMixin
    ],

    data () {
        return {
            pageTitle: 'Boka tid',
            showPageHeader: false
        }
    }

}
</script>
